import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/layout/Layout";
import useTemplate from "./use-template";

function Index() {
  const navigate = useNavigate();

  const {
    isUpdating,
    templates,
    selectedTemplate,
    setSelectedTemplate,
    handleUpdateTemplate,
  } = useTemplate();

  return (
    <Layout header headerTitle="Update Template">
      <div className="w-full lg:max-w-screen-md h-screen mx-auto flex flex-col items-center justify-between pb-5 pt-24 px-4">
        <div className="mb-3 w-full">
          <p className="text-base font-semibold mb-2">
            Select your desired template
          </p>
          {templates && (
            <select
              className="form-select appearance-none block w-full h-[58px] px-3 py-1.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-purple-40 focus:outline-none focus:shadow"
              aria-label="Select template"
              required
              value={templates.find((t) => t.id === selectedTemplate?.id)?.id}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value, 10);
                const template = templates.find((t) => t.id === selectedId);
                setSelectedTemplate(template);
              }}
            >
              <option value="">Select your desired template</option>
              {templates?.map((template) => (
                <option key={template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
            </select>
          )}
          {selectedTemplate && selectedTemplate.name === "commerce" && (
            <div className="mt-4 rounded-lg bg-yellow-50 p-4 text-sm text-yellow-900 shadow-sm">
              <p className="mb-2 font-semibold">Commerce Template</p>
              <p className="mb-3">
                This template provides a complete eCommerce experience.
                Customers can search for products from any screen, browse by
                category, adjust item quantities while shopping, and view a
                clear order summary showing totals per item and the overall
                total during checkout.
              </p>
              <p className="mb-2 font-bold">Important things to know:</p>
              <ul className="list-disc space-y-1 pl-5">
                <li>Only categorized products will appear on your website.</li>
                <li>
                  Products without prices will default to{" "}
                  <strong>Ksh 0.00</strong>.
                </li>
              </ul>
            </div>
          )}
        </div>
        <button
          disabled={isUpdating}
          type="button"
          className="w-full h-16 text-white thryve:text-base text-base font-semibold rounded-xl bg-primary-50"
          onClick={() => handleUpdateTemplate(() => navigate("/account"))}
          onKeyDown={(e) =>
            e.key === "Enter" &&
            handleUpdateTemplate(() => navigate("/account"))
          }
        >
          {isUpdating ? "Updating..." : "Update"}
        </button>
      </div>
    </Layout>
  );
}

export default Index;
